import * as React from 'react';
import { css } from '@emotion/react';
import { useRouter } from 'next/router';
import { DesignSystemProvider } from '@zapier/design-system';
import { UniversalLayout } from '@zapier/universal-layout';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { NotificationProvider } from '@zapier/auth-pages';

import { isOwnedRoute } from './ownedRoutes';

type Props = {
  children: React.ReactNode;
};

const rootStyle = css`
  box-sizing: border-box;
  min-height: 100%;
  display: grid;
  position: relative;
`;

export function PageLayout(props: Props) {
  const { trackEvent } = useTrackingContext();
  const router = useRouter();

  // Memoised because RouterProvider keys its context on the navigate identity;
  // a new arrow each render re-renders every design-system Link beneath it.
  const navigate = React.useCallback(
    (path: string) => {
      if (isOwnedRoute(path)) {
        void router.push(path);
      } else {
        window.location.href = path;
      }
    },
    [router]
  );

  return (
    <DesignSystemProvider navigate={navigate}>
      <NotificationProvider notificationTimeout={30000}>
        <UniversalLayout
          currentUrl={router.asPath}
          trackEvent={trackEvent}
          // We do not want to render alerts on these pages
          renderAlertBanner={() => null}
          // We do not want to render a footer on these pages
          renderFooter={() => null}
        >
          <div css={rootStyle}>{props.children}</div>
        </UniversalLayout>
      </NotificationProvider>
    </DesignSystemProvider>
  );
}
